import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as PingActions from './ping.actions';
import { FundSourceTypeEnum, PingService } from '@classifieds-sell/datalayer';

@Injectable()
export class PingEffects {
    pingFundSources$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PingActions.getFundSources),
            mergeMap(() => {
              return this.pingService.getFundSources().pipe(
                map((fundSources) =>
                  PingActions.getFundSourcesSuccess({ fundSources })
                ),
                catchError((err) =>
                  of(PingActions.getFundSourcesFailure(err))
                )
              )
              }
            )
        )
    );

    deleteFundSource$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PingActions.deleteFundSources),
            mergeMap((action) => {
                let type = FundSourceTypeEnum[action.fundSource.type];
                type = type[0].toUpperCase() + type.substring(1);
                return this.pingService
                    .removeFundSource(type, action.fundSource.fundSourceId)
                    .pipe(
                        map((resp) =>
                            resp.success
                                ? PingActions.deleteFundSourcesSuccess({
                                      fundSource: action.fundSource
                                  })
                                : PingActions.deleteFundSourcesFailure({
                                      // TODO: use ErrorModel instead,
                                      // but this first requires refactoring
                                      // of ErrorModel to be moved to datalayer lib
                                      error: new Error(
                                          'Failed to delete fund source'
                                      ),
                                      fundSource: action.fundSource
                                  })
                        ),
                        catchError((error) =>
                            of(
                                PingActions.deleteFundSourcesFailure({
                                    error,
                                    fundSource: action.fundSource
                                })
                            )
                        )
                    );
            })
        )
    );

    constructor(private actions$: Actions, private pingService: PingService) {}
}
